import { render, staticRenderFns } from "./plan-details-dialog.vue?vue&type=template&id=1d1bf656&scoped=true"
import script from "./plan-details-dialog.vue?vue&type=script&lang=js"
export * from "./plan-details-dialog.vue?vue&type=script&lang=js"
import style0 from "./plan-details-dialog.vue?vue&type=style&index=0&id=1d1bf656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1bf656",
  null
  
)

export default component.exports